import Typography from "@mui/material/Typography";
import {GenreSelectorMultiple} from "@/components/bandcreate/GenreSelectorMultiple";
import CheckboxStyled from "@/components/CheckboxStyled";

const NetworkLocationFormStudios = ({onChange}) => {
    const handleInputChanged = (event, value) => {
        if (onChange && typeof onChange === "function") {
            onChange(event, value);
        }
    }

    const handleCheckboxChanged = (event) => {
        event.target.value = event.target.checked;

        if (onChange && typeof onChange === "function") {
            onChange(event);
        }
    };

    return (
        <>
            <Typography variant="h4" component="p" color="common.black" sx={{ mt: 4,}}>
                Orts-spezifische Angaben (Studios)
            </Typography>
            <GenreSelectorMultiple
                label="Genre *"
                hint="Wähle bis zu vier"
                maxCount="4"
                onChange={handleInputChanged}
            />
            <CheckboxStyled
                label="Angebot Aufnahme"
                name="recording"
                onChange={handleCheckboxChanged}
                marginTop
            />
            <CheckboxStyled
                label="Angebot Mixing"
                name="mixing"
                onChange={handleCheckboxChanged}
                marginTop
            />
            <CheckboxStyled
                label="Angebot Mastering"
                name="mastering"
                onChange={handleCheckboxChanged}
                marginTop
            />
        </>
    )
}

export default NetworkLocationFormStudios;
